import Sitemap from "../../config/sitemap.json";
import { NavLink, useLocation } from "react-router-dom";
import "./header.css";
import logoCristinaNuovo from "../../assets/logoCristinaNuovo.jpeg";

export const Header = () => {
    const location = useLocation();
    return (
        <>
            {location.pathname != "/" && (
                <header className="d-flex align-items-center container-fluid bgBlue px-5 justify-content-between">
                    <NavLink to="/">
                        <img className="logo-header" src={logoCristinaNuovo} alt="DoulaCristina" />
                    </NavLink>

                    <ul className="d-flex align-items-center gap-5 fs-3 m-0">
                        {Sitemap.map((el) => {
                            return (
                                <NavLink to={el.link} key={el.id} className="text-white fs-5 underline-none">
                                    {el.name}
                                </NavLink>
                            );
                        })}
                    </ul>
                    <div></div>
                </header>
            )}
        </>
    );
};
